import { harvestYearDetail } from "../../config/harvestYearDetail";
import { userDetail } from "../../config/userDetails";
import DropdownOptions from "../../constants/DropdownOptions";
import { globalApiHandler } from "../../services/services";
import { formatDate } from "../../utils/DateFormatter";

export const FIELD = {
  list: {
    success: "FIELD_GET_ALL_SUCCESS",
    error: "FIELD_GET_ALL_ERROR"
  },
  create: {
    success: "FIELD_CREATE_SUCCESS",
    error: "FIELD_CREATE_ERROR"
  },
  edit: {
    success: "FIELD_EDIT_SUCCESS",
    error: "FIELD_EDIT_ERROR"
  },
  update: {
    success: "FIELD_UPDATE_SUCCESS",
    error: "FIELD_UPDATE_ERROR"
  },
  delete: {
    success: "FIELD_DELETE_SUCCESS",
    error: "FIELD_DELETE_ERROR"
  }
};

export const fieldListAction = (
  id,
  harvestYear = harvestYearDetail().name,
  fieldGroupId
) => {
  return (dispatch, getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    let url = !userDetail().parentFarmId
      ? `/ntrac/fieldgroup/farmFields/${selectedMainFarm}/${harvestYear}?fieldGroupId=${fieldGroupId}`
      : `/ntrac/fieldgroup/farmFields/${
          userDetail().parentFarmId
        }/${harvestYear}?fieldGroupId=${fieldGroupId}`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        data.map(item => {
          item.updatedAt = formatDate(item.updatedAt);
        });
        dispatch({ type: FIELD.list.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const createFieldAction = fieldInfo => {
  return (dispatch, getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    let url =
      selectedMainFarm !== DropdownOptions.ALL_MAIN_FARM.id
        ? `/ntrac/fieldgroup/field?farmId=${selectedMainFarm}`
        : `/ntrac/fieldgroup/field`;
    globalApiHandler(url, "post", fieldInfo)
      .then(response => {
        dispatch({ type: FIELD.create.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const editFieldAction = data => {
  return dispatch => {
    dispatch({ type: FIELD.edit.success, data });
  };
};

export const updateFieldAction = fieldInfo => {
  let url = `/ntrac/fieldgroup/field/${fieldInfo.id}`;
  return (dispatch, getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    let url =
      selectedMainFarm !== DropdownOptions.ALL_MAIN_FARM.id
        ? `/ntrac/fieldgroup/field/${fieldInfo.id}?farmId=${selectedMainFarm}`
        : `/ntrac/fieldgroup/field/${fieldInfo.id}`;
    globalApiHandler(url, "put", fieldInfo)
      .then(response => {
        dispatch({ type: FIELD.update.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const deleteFieldAction = id => {
  let url = `/ntrac/fieldgroup/field/${id}`;
  return dispatch => {
    globalApiHandler(url, "delete", {})
      .then(response => {
        const data = response.data.data;
        dispatch({ type: FIELD.delete.success, data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/fields/action.js